module.exports = __webpack_public_path__ + "static/media/Icons_assigned_jobs.3dde2c2e.svg";